import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormEditMembershipService } from "./FormEditMembershipService";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import {FormEditMembership} from "../../Membership/Edit/FormEditMembership";

export const PanelEditMembershipService = () => {
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [membershipData, setMembershipData] = useState(null);

    const [groups, setGroups] = useState([]);
    const [isGroupsLoading, setIsGroupsLoading] = useState(true);

    const fetchData = async () => {
        try {
            // Fetch membership details
            const { response: membershipResponse } = await Helper.Get({
                url: `${api_Routes.MembershipService.ViewDetails}${id}`,
            });
            const { response: groupsResponse } = await Helper.Get({
                url: api_Routes.MembershipGroup.ViewAll,
            });

            if (membershipResponse && groupsResponse) {
                setMembershipData({
                    ...membershipResponse.data,
                    is_active: Boolean(membershipResponse.data.is_active),
                    all: Boolean(membershipResponse.data.all),
                    groups: membershipResponse.data.groups?.map(s => s.id) || []
                });
                setGroups(groupsResponse.data)
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
            setIsGroupsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <PanelHead
                title={
                    isLoading ? (
                        <div className="flex items-center gap-4">
                            Edit Membership <CircularProgress size={24} />
                        </div>
                    ) : (
                        <div className="flex items-center justify-between w-full gap-4">
                            <div>Edit Membership: {membershipData?.name}</div>
                        </div>
                    )
                }
            />
            <PanelBody
                content={
                    isLoading ? (
                        <LinearProgress />
                    ) : (
                        <FormEditMembershipService
                            membershipData={membershipData}
                            setMembershipData={setMembershipData}
                            groups={groups}
                            isGroupsLoading={isGroupsLoading}
                        />
                    )
                }
            />
        </div>
    );
};
